import React, { ReactNode } from 'react'
import cx from 'classnames'
import styleProvider, {
  NumberOfCols,
} from '@quotatisgroup/uikit-public.style-provider'
import './col.scss'

export type ColProps = {
  className?: string
  classes?: string
  children?: ReactNode
  sm?: NumberOfCols
  md?: NumberOfCols
  offset?: NumberOfCols
  marginHorizontalAuto?: boolean
}

/**
 * Col
 *
 * @param {node} children React node
 * @param {string} sm number of cols for small device width
 * @param {string} md number of cols for medium device width
 * @param {string} offset number of offset cols
 * @param {bool} marginHorizontalAuto horizontal center content
 */
const ColComponent = ({
  className,
  classes,
  children,
  sm,
  md,
  offset,
  marginHorizontalAuto = false,
}: ColProps) => {
  return (
    <div
      className={cx(
        classes,
        {
          [`sm-col-${sm}`]: sm,
          col: !sm || !md,
          [`col-${md}`]: md,
          [`offset-${offset}`]: offset,
          ['margin-horizontal-auto']: marginHorizontalAuto,
        },
        className,
      )}
    >
      {children}
    </div>
  )
}

export const Col = styleProvider(ColComponent)
